import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="py-32 text-center" data-testid="notfound-page">
      <div className="max-w-xl mx-auto px-5">
        <div className="eyebrow mb-4">404</div>
        <h1 className="display-lg mb-4">Page not found.</h1>
        <p className="text-[color:var(--muted)] mb-8">The page you&apos;re looking for doesn&apos;t exist, or was moved.</p>
        <Link to="/" className="btn-primary">Back home</Link>
      </div>
    </section>
  );
}
